import { Skeleton, useTheme } from '@mui/material'
import CompanyLogo from '../../../../../components/company-logo/company-logo.component'
import {
  Background,
  Container,
  LeftContainer,
  SettingsButton,
} from '../../settings-details.styles'
import AddLogoSettingsDialog from '../../../../../components/add-logo-settings-dialog/add-logo-settings-dialog.component'
import { useEffect, useState } from 'react'
import { useGetLogoPresignedUrlMutation } from 'store/task-automation/task-automation.api'
import { getUserId } from 'utils/common'

const SettingsLogo = () => {
  const userId = getUserId()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const [imageUri, setImageUri] = useState('')

  const [getLogoPresignedUrl, { isLoading }] = useGetLogoPresignedUrlMutation()

  const fetchLogo = async () => {
    try {
      const response = await getLogoPresignedUrl({
        user_id: userId,
      }).unwrap()
      setImageUri(response.presignedUrl)
    } catch (error) {
      console.error('Error fetching logo:', error)
    }
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    fetchLogo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <>
      <Background theme={theme} background="dark">
        <Container>
          <LeftContainer>
            {isLoading ? (
              <Skeleton variant="rounded" width={100} height={100} />
            ) : imageUri ? (
              <CompanyLogo src={imageUri} maxHeight={100} maxWidth={240} />
            ) : null}
          </LeftContainer>
          <SettingsButton variant="contained" size="small" onClick={handleOpen}>
            Add Logo
          </SettingsButton>
        </Container>
      </Background>
      <AddLogoSettingsDialog open={open} handleClose={handleClose} />
    </>
  )
}

export default SettingsLogo
